/**
 * Copia um texto para a área de transferência e diz se copiou DE FATO.
 *
 * O navegador só deixa escrever na área de transferência em contexto seguro e, no Safari e no
 * Firefox, dentro do gesto do usuário. Quando a cópia vem depois de uma requisição (o link de
 * assinatura do contrato, EAS-264), o gesto já passou: `navigator.clipboard.writeText` rejeita e o
 * `document.execCommand('copy')` devolve `false` sem lançar. Quem chama precisa do resultado para
 * não anunciar "copiado" quando nada foi copiado, e oferecer a cópia manual.
 */
export async function copyText(text: string,
                               nav: Navigator = navigator,
                               doc: Document = document): Promise<boolean> {
  if (!text) {
    return false;
  }
  if (nav && nav.clipboard && typeof nav.clipboard.writeText === 'function') {
    try {
      await nav.clipboard.writeText(text);
      return true;
    } catch {
      // sem permissão ou fora do gesto: tenta o caminho antigo
    }
  }
  return execCommandCopy(text, doc);
}

function execCommandCopy(text: string, doc: Document): boolean {
  if (!doc || !doc.body) {
    return false;
  }
  const textarea = doc.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  doc.body.appendChild(textarea);
  try {
    textarea.focus();
    textarea.select();
    return doc.execCommand('copy') === true;
  } catch {
    return false;
  } finally {
    doc.body.removeChild(textarea);
  }
}
